module.exports = __webpack_public_path__ + "static/media/profile-pic.5db2517e.jpg";